<template>
  <section class="py-[64px]">
    <div class="section__header text-center">
      <h1 class="m-0 text-[24px] font-semibold leading-[32px]">
        {{ splitTitle(in18["page_contact_us_title"])?.first }}
        <span :class="['text-lime-green ']">
          {{ splitTitle(in18["page_contact_us_title"])?.last }}
        </span>
      </h1>
      <div class="text-[16px] font-light text-medium-gray mt-[8px]">
        {{ in18["page_contact_us_description"] }}
      </div>
      <div class="w-full h-1 my-[24px] mb-[48px] border-b border-light-gray/25">
        <div class="mx-auto w-[56%] md:w-[10%] h-1" :class="['bg-lime-green ']" />
      </div>
    </div>
    <div class="container-lg flex md:flex-row flex-col gap-[16px] mb-[48px]">
      <div
        class="p-[32px] flex-1 flex flex-col items-center rounded-[8px] border border-charcoal/[7%] shadow-base"
      >
        <div
          class="w-[60px] h-[60px] p-[16px] flex -tems-center justify-center border border-l-charcoal rounded-full mb-[20px]"
        >
          <img alt="Envelope icon" class="" src="/shop/images/envelope-icon.svg" />
        </div>
        <span class="text-[18px] leading-[28px] font-medium">
          {{ in18["attribute_email"] }}
        </span>
        <a
          :href="'mailto:' + in18['page_info_email']"
          class="text-[16px] leading-[24px] text-medium-gray"
          :title="in18['page_info_email']"
        >
          {{ in18["page_info_email"] }}
        </a>
      </div>

      <div
        class="p-[32px] flex-1 flex flex-col items-center rounded-[8px] border border-charcoal/[7%] shadow-base"
      >
        <div
          class="w-[60px] h-[60px] p-[16px] flex -tems-center justify-center border border-l-charcoal rounded-full mb-[20px]"
        >
          <img alt="phone icon" class="" src="/shop/images/phone-icon.svg" />
        </div>
        <span class="text-[18px] leading-[28px] font-medium">
          {{ in18["attribute_phone"] }}
        </span>
        <a
          :href="'tel:' + in18['page_phone_1']"
          class="text-[16px] leading-[24px] text-medium-gray"
          :title="in18['page_phone_1']"
        >
          {{ in18["page_phone_1"] }}
        </a>
        <!-- <a :href="'tel:' + in18['page_phone_2']" class="text-[16px] leading-[24px] text-medium-gray" :title="in18['page_phone_2']">
          {{ in18['page_phone_2'] }}
        </a>       -->
      </div>

      <div
        class="p-[32px] flex-1 flex flex-col items-center rounded-[8px] border border-charcoal/[7%] shadow-base"
      >
        <div
          class="w-[60px] h-[60px] p-[16px] flex -tems-center justify-center border border-l-charcoal rounded-full mb-[20px]"
        >
          <img alt="location icon" class="" src="/shop/images/location-icon.svg" />
        </div>
        <span class="text-[18px] leading-[28px] font-medium">
          {{ in18["attribute_location"] }}
        </span>
        <span class="text-[16px] leading-[24px] text-medium-gray">
          {{ in18["page_actual_address"] }}
        </span>
      </div>
    </div>
    <div class="bg-[#F8F8F8] py-[54px]">
      <div class="container-lg flex flex-col items-center">
        <form class=" flex flex-col gap-[12px] w-[90%] sm:w-[80%]  md:w-1/2" @submit.prevent="submitForm">
          <h2 class="text-[20px] leading-[28px] font-semibold my-0 text-center">
            {{ in18["page_send_us_title"] }}
          </h2>
          <span class="text-[16px] text-medium-gray font-light text-center">
            {{ in18["page_send_us_message"] }}
          </span>

          <div class="flex flex-col pt-[18px]">
            <input
              id="contact_name"
              v-model="contact.name"
              class="px-[16px] py-[14px] bg-white border border-very-light-gray rounded-[8px] outline-none placeholder:text-[14px] placeholder:font-light"
              :placeholder="in18['page_first_name_label']"
              name="contact_name"
              type="text"
            />
            <span v-if="errors['name']?.length" class="!text-[12px] text-[#eb2635]">*{{errors['name']?.[0]}}</span>
          </div>
          <!-- Name -->

          <div class="flex flex-col">
            <input
              id="contact_email"
              v-model="contact.email"
              class="px-[16px] py-[14px] bg-white border border-very-light-gray rounded-[8px] outline-none placeholder:text-[14px] placeholder:font-light"
              :placeholder="in18['page_email_label']"
              name="contact_email"
              type="email"
            />
            <span v-if="errors['email']?.length" class="!text-[12px] text-[#eb2635]">*{{errors['email']?.[0]}}</span>
          </div>
          <!-- Email -->

          <div class="flex flex-col">
            <textarea
              v-model="contact.message"
              class="px-[16px] py-[14px] bg-white border border-very-light-gray rounded-[8px] outline-none placeholder:text-[14px] placeholder:font-light"
              :placeholder="in18['page_message_label']"
              rows="4"
              name="contacts_message"
            ></textarea>
            <span v-if="errors['message']?.length" class="!text-[12px] text-[#eb2635]">*{{errors['message']?.[0]}}</span>
          </div>
          <!-- Message -->

          <google-recaptcha-v3
            id="contact"
            ref="captcha"
            v-model="contact.gRecaptchaResponse"
            :site-key="captcha_site_key"
            action="contact_action"
            corner
          />
          <validation-error :errors="errors['gRecaptchaResponse']"></validation-error>

          <button class="btn btn--green btn--block btn--md" type="submit">
            {{ in18["page_send_form"] }}
          </button>
        </form>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, reactive, onMounted, nextTick } from "vue";
import axios from "axios";

// Define props
const props = defineProps({
  in18: {
    type: Object,
    required: true,
  },
  captcha_site_key: {
    type: String,
    required: true,
  },
});

// Reactive data
const inProgress = ref(false);
const errors = reactive({});
const contact = reactive({
  gRecaptchaResponse: null,
  name: null,
  email: null,
  message: null,
});

const recaptchaLoaded = ref(false);

// Refs
const captcha = ref(null);

// Methods
const initRecaptcha = () => {
  if (!recaptchaLoaded.value) {
    captcha.value.init();
    recaptchaLoaded.value = true;
  }
};

const submitForm = () => {
  if (inProgress.value) return;

  inProgress.value = true;

  axios
    .post("/api/page/contact", contact)
    .then((response) => {
      window.toastr.success(response.data.message);
      Object.keys(errors).forEach((key) => (errors[key] = []));
      contact.gRecaptchaResponse = null;
      contact.name = null;
      contact.email = null;
      contact.message = null;
    })
    .catch((error) => {
      window.toastr.error(error.response.data.message);
      Object.assign(errors, error.response.data.errors);
      nextTick(() => {
        window.scrollToErrorMessage();
      });
    })
    .finally(() => {
      inProgress.value = false;
      captcha.value.execute();
    });
};

const splitTitle = (string) => {
  if (!string) return {};
  const words = string.split(" ");
  const last = words.pop();
  return {
    first: words.join(" "),
    last,
  };
};

// Lifecycle hooks
onMounted(() => {
  initRecaptcha();
});
</script>
